<template>
  <div>
    <money v-model="price" v-bind="money" class="form-control"></money>
  </div>
</template>

<script>
  import {Money} from 'v-money'

  export default {
    components: {Money},

    data () {
      return {
        price: 123.45,
        money: {
          decimal: ',',
          thousands: '.',
          prefix: ' ',
          suffix: ' ',
          precision: 0,
          masked: false
        }
      }
    }
  }
</script>
